export * from './routes';
export * from './resCodes';
export { default as URL } from './URL';

export const isProduction = true;

export const apiV1BaseUrl = isProduction
  ? 'https://agroglorytime.io/api/v2'
  : 'https://agti-token.rocknblock.io/api/v2';
